import {Dialog, Toast} from 'vant';


export default {

    install: function (Vue, options) {

        /**
         * Toast 弹出
         */
        Vue.prototype.BRToast = function (title = '提示') {
            Toast({
                mask: false, //是否显示蒙版
                message: title
            });
        };

        /**
         * Dialog 弹出
         * @param title
         * @param message
         * @param yesCallback
         * @param cancelCallback
         * @constructor
         */
        Vue.prototype.BRDialog = function (title = '提示', message, yesCallback, cancelCallback) {
            Dialog.confirm({
                title: title,
                message: message,
                showCancelButton: false //取消按钮
            }).then(() => {
                //点击确认按钮后的调用
                if (yesCallback) {
                    yesCallback();
                }
            }).catch(() => {
                //点击取消按钮后的调用
                if (cancelCallback) {
                    cancelCallback();
                }
            });
        };

        /**
         * loading 显示
         * @param title
         * @param duration
         */
        Vue.prototype.BRShowLoad = function (title = '加载中', duration = 2000) {
            Toast.loading({
                mask: true,
                message: title,
                duration: duration, //当前显示时间
                forbidClick: true //禁止点击背景
            });
        };

        /**
         * loading 隐藏
         */
        Vue.prototype.BRHideLoad = function () {
            Toast.clear();
        };


        /**
         * 网页后退   -1,-2,-3
         * @constructor
         */
        Vue.prototype.BRUrlBack = function () {
            this.$router.back(-1)
        }


        /**
         * 判断字符是否存在
         * @param str
         * @returns {boolean}
         */
        Vue.prototype.isSetString = function (str) {
            if (str !== null && str !== undefined && str !== '') {
                return true;
            } else {
                return false;
            }
        };
        Vue.prototype.dataEq = function (str1, str2) {
            if (str1 !== str2) {
                return false;
            } else {
                return true;
            }
        };

        /**
         * 网站运行系统
         * @returns {string}
         */
        Vue.prototype.runRomSystem = function () {
            let u = navigator.userAgent;
            let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
            let isIOS = u.match(/iPhone|iPad|iPod|ipad|Mac|mac/i); //IOS终端
            let isIE = u.match(/IEMobile/i);
            return isIOS ? 'ios' : 'android';
        };

        /**
         * 判断是否在微信APP内运行
         * @returns {boolean}
         */
        Vue.prototype.isRunInWeChatApp = function () {
            let ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true;
            } else {
                return false;
            }
        };

        /**
         * 获取URL地址参数
         * @returns {any[]}
         */
        Vue.prototype.getUrlParamsCode = function () {
            let URLParams = new Array();
            let aParams = document.location.search.substr(1).split('&');
            for (let i = 0; i < aParams.length; i++) {
                let aParam = aParams[i].split('=');
                URLParams[aParam[0]] = decodeURI(aParam[1]);
            }
            return URLParams;
        };

        // 获取微信重定向后的参数code
        // getRequest () {
        //     var url = window.location.search; // 获取url中"?"符后的字串
        //     var theRequest = {};
        //     if (url.indexOf("?") != -1) {
        //         var str = url.substring(url.indexOf("?") + 1);
        //         var strs = str.split("&");
        //         for (var i = 0; i < strs.length; i++) {
        //             theRequest[strs[i].split("=")[0]] = decodeURIComponent(strs[i].split("=")[1]);
        //         }
        //     }
        //     return theRequest;
        // },

    }
};



// WEBPACK FOOTER //
// ./src/utils/util.js